var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagihankosong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 167,
    viewBox: "0 0 267 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_15751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.582 123.312C169.62 97.3484 97.2012 96.8829 31.9086 122.009L22.7256 125.553C22.9113 132.571 25.8386 139.24 30.8842 144.139C35.9298 149.039 42.6949 151.781 49.7387 151.781H217.275C224.04 151.779 230.559 149.248 235.544 144.689C240.529 140.13 243.619 133.874 244.203 127.156L234.582 123.312Z",
    fill: "#0888A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.582 123.312L244.203 127.156C244.268 126.387 244.307 125.618 244.307 124.836V41.004C244.307 33.8571 241.459 27.0029 236.39 21.9486C231.321 16.8944 224.445 14.0541 217.275 14.0524H49.7321C42.5665 14.061 35.6974 16.9044 30.6336 21.9578C25.5699 27.0113 22.7256 33.8617 22.7256 41.004V124.836C22.7256 125.077 22.7256 125.312 22.7256 125.553L31.9151 122.015C97.2049 96.889 169.621 97.3522 234.582 123.312Z",
    fill: "#08A8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.98 97.8129L180.876 71.8059L180.719 126.941L135.823 152.948L135.98 97.8129Z",
    fill: "#F89808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.98 97.813L135.823 152.948L87.5029 125.136L87.6598 70.0013L135.98 97.813Z",
    fill: "#F8B818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6602 70.0014L132.556 95.839V43.9944L87.6602 70.0014Z",
    fill: "#F8D818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.876 71.806L132.556 43.9944V95.839L135.981 97.813L180.876 71.806Z",
    fill: "#F8B818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6605 70.0013L72.2422 94.4774L123.314 125.299L135.981 97.813L87.6605 70.0013Z",
    fill: "#F89808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.98 97.8129L152.817 119.644L195.092 89.6694L180.876 71.8059L135.98 97.8129Z",
    fill: "#F8D818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.078 113.279V141.495",
    stroke: "#D37902",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.719 126.941L160.478 138.381",
    stroke: "#D37902",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.085 141.495L145.157 147.149",
    stroke: "#D37902",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51 43.0237C118.518 40.7719 119.169 38.5689 120.386 36.6718C121.796 34.4005 123.776 32.5347 126.131 31.258C128.869 29.7538 131.945 28.967 135.072 28.9713C137.975 28.8529 140.867 29.3942 143.529 30.5544C145.837 31.5492 147.825 33.1587 149.274 35.2059C150.617 37.1184 151.357 39.3868 151.399 41.7207C151.472 43.4163 151.117 45.103 150.366 46.6264C149.687 47.9782 148.805 49.2193 147.752 50.3072C146.732 51.3409 144.898 53.089 142.248 55.5516C141.634 56.1294 141.049 56.7383 140.497 57.3758C140.117 57.814 139.79 58.295 139.523 58.809C139.318 59.2261 139.156 59.6626 139.039 60.112C138.928 60.5419 138.758 61.2911 138.542 62.3661C138.17 64.6528 136.889 65.8124 134.699 65.858C134.169 65.8841 133.64 65.8041 133.141 65.6229C132.643 65.4416 132.186 65.1627 131.797 64.8026C131.377 64.3739 131.051 63.8632 130.838 63.3027C130.625 62.7421 130.531 62.1437 130.562 61.5452C130.392 58.4736 131.452 55.4603 133.51 53.1672C134.694 51.8688 135.944 50.6316 137.255 49.4603C138.636 48.2095 139.632 47.2648 140.242 46.6264C140.85 45.9974 141.367 45.2869 141.778 44.5156C142.189 43.7445 142.391 42.8801 142.366 42.0074C142.361 41.1723 142.175 40.3481 141.821 39.5913C141.467 38.8345 140.953 38.1631 140.314 37.6229C138.906 36.4163 137.081 35.8061 135.229 35.9226C132.817 35.9747 131.052 36.6131 129.935 37.877C128.637 39.4701 127.688 41.3165 127.15 43.2973C126.457 45.786 125.07 47.052 122.987 47.0954C122.407 47.116 121.829 47.0173 121.29 46.8055C120.75 46.5936 120.26 46.2732 119.85 45.8641C119.444 45.5066 119.116 45.0703 118.885 44.5818C118.655 44.0934 118.527 43.5632 118.51 43.0237ZM135.314 78.6335C134.026 78.6787 132.768 78.2444 131.784 77.4152C131.27 76.9705 130.861 76.4168 130.589 75.7947C130.316 75.1725 130.187 74.4976 130.209 73.8191C130.183 73.1721 130.291 72.5266 130.527 71.9234C130.764 71.3202 131.123 70.7723 131.582 70.3141C132.041 69.8442 132.589 69.4707 133.196 69.2156C133.802 68.9605 134.453 68.8289 135.111 68.8287C135.757 68.807 136.401 68.9145 137.005 69.145C137.608 69.3754 138.159 69.7241 138.625 70.1705C139.092 70.6169 139.463 71.1519 139.718 71.7439C139.974 72.3359 140.107 72.9728 140.111 73.6171C140.161 74.2889 140.06 74.9633 139.817 75.5918C139.575 76.2204 139.195 76.7875 138.706 77.2524C137.792 78.1246 136.579 78.6182 135.314 78.6335Z",
    fill: "#E5152E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3662 67.6691L79.9348 68.7766",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7188 48.1508L96.6207 54.8089",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.745 39.5056L113.641 45.1604",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.366 53.1411L165.373 46.3788",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.713 57.7992L188.295 47.2648",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.732 66.4508L196.079 65.6755",
    stroke: "#F8D818",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_15751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 167,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagihankosong);
export default __webpack_public_path__ + "static/media/tagihankosong.ff642972c8dc3bfc267f15af31f5966c.svg";
export { ForwardRef as ReactComponent };